// Keeps the browser tab's title honest as the visitor moves around the SPA.
//
// The Worker's rewrite (worker/unfurl.js) only ever sees a fresh HTTP request, so
// it covers a crawler and a cold arrival on a share link — and nothing else. Every
// click inside the app is a client-side route change with no HTML fetched, so
// without this the tab keeps whichever title the page was loaded with: open /,
// click through to a specimen, and the tab still says "find the one that's yours".
// A bookmark or a restored session then records that wrong title permanently.
//
// Titles only. It does not touch the meta description or the og: tags, and that is
// not laziness: the only consumer of those is a crawler, and a crawler never runs
// this code. Rewriting them here would be work that no reader can ever observe.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { metaForPath } from './unfurl';

const useDocumentTitle = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const { title } = metaForPath(pathname);
        // Guarded because on a cold load of /g/:token the Worker has ALREADY put
        // the right title in the served HTML, and reassigning an identical string
        // is a no-op we can skip rather than a change to make.
        if (document.title !== title) document.title = title;
    }, [pathname]);
};

export default useDocumentTitle;
